<template>
  <div>
    <van-nav-bar
      title="我的订单"
      left-text="返回"
      left-arrow
      @click-left="clickback"/>
    <van-search
        v-model="query.prd_name"
        placeholder="请输入商品名称"
        shape="round"
        show-action
        @search="onSearch">
        <div slot="action" @click="onSearch">搜索</div>
    </van-search>
    <!-- <van-loading vertical v-if="loading"/> -->
    <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad">
        <orderitem v-for="itm in data" :key="itm.id" :item="itm" />
    </van-list>
    <!-- <van-pagination 
        v-model="query.page" 
        :total-items="total"
        @change="chgPage"
        mode="simple"/> -->
  </div>
</template>

<script>
import { OrderApi } from '@/api/market'
import { 
    NavBar, 
    Tab, 
    Tabs, 
    Card, 
    Search, 
    // Pagination, 
    Button, 
    Loading,
    List
} from 'vant'
import orderitem from '@/view/user/components/orderitem'

export default {
    components: {
        [NavBar.name]: NavBar,
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        [Card.name]: Card,
        // [Pagination.name]: Pagination,
        [Search.name]: Search,
        [Button.name]: Button,
        [Loading.name]:Loading,
        [List.name]:List,
        orderitem
    },
    data() {
        return {
            data: [],
            total: 0,
            loading: false,
            finished: false,
            query: {
                prd_name: null,
                state: 0,
                page: 1,
                page_size: 10
            }
        }
    },
    mounted() {
        if (this.$route && this.$route.params && this.$route.params.id) {
            switch (this.$route.params.id) {
                case '9':
                    this.query.state = -1
                    break
                case '100':
                    this.query.state = null
                    break;
                default:
                    this.query.state = this.$route.params.id
                    break;
            }
        }
        this.getData()
    },
    methods: {
        clickback() {
            try {
                this.$router.go(-1)
            } catch {
                this.$router.push(`/user`)
            }
        },
        tabClick(tabindex) {
            this.query.state = tabindex
            this.getData()
        },
        getData() {
            var that = this
            that.loading = true
            that.axios.get(OrderApi, {params: that.query}).then((ret) => {
                that.loading = false
                that.total= ret.count
                if (ret.results == null || ret.results.length ===0 ) {
                    that.finished = true
                    return
                }
                that.data = that.data.concat(ret.results)
                if (that.data.length >= that.total) {
                    that.finished = true
                }
            }).catch(function (error) {
                that.loading = false
                that.finished = true
                console.log(error)
            })
        },
        onSearch() {
            this.query.page = 0
            this.getData()
        },
        onLoad() {
            console.log('onload')
            this.query.page = this.query.page + 1
            this.getData()
        },
        cancelItem(itm) {
            var that = this
            console.log(itm)
            const data = {
                id: itm.id,
                action: 'cancel'
            }
            that.axios.put(OrderApi + itm.id + '/',data).then((ret) => {
                console.log(ret)
            })
        },
        hideItem(itm) {
            const data = {
                id: itm.id,
                action: 'hide'
            }
            this.axios.put(OrderApi + itm.id + '/', data).then((ret) => {
                console.log(ret)
            })
        }
    }
}
</script>

<style>

</style>